__turbopack_context__.v({
  "additionalType": "p5p3la_additionalType",
  "additionalTypeDetails": "p5p3la_additionalTypeDetails",
  "additionalTypeSummary": "p5p3la_additionalTypeSummary",
  "componentDescription": "p5p3la_componentDescription",
  "componentName": "p5p3la_componentName",
  "returnType": "p5p3la_returnType",
  "typeContent": "p5p3la_typeContent",
});
